import { apiGet } from '@/services/api/apiClient';
import { API_ENDPOINTS } from '@/constants/endpoints';
import {
  BookingLogListParams,
  BookingLogListResponse,
} from '@/constants/types';

class BookingLogsService {
  async list(params: BookingLogListParams): Promise<BookingLogListResponse> {
    try {
      const queryParams = new URLSearchParams();
      if (params.sortDir) queryParams.append('sortDir', params.sortDir);
      if (params.limit !== undefined) queryParams.append('limit', params.limit.toString());
      if (params.offset !== undefined) queryParams.append('offset', params.offset.toString());
      if (params.search_string !== undefined) queryParams.append('search_string', params.search_string);
      if (params.sortBy) queryParams.append('sortBy', params.sortBy);

      const url = `${API_ENDPOINTS.BOOKING_LOGS.LIST}?${queryParams.toString()}`;
      const response = await apiGet<BookingLogListResponse>(url, { showLoader: true });
      return response;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to fetch booking logs');
    }
  }
}

export const bookingLogsService = new BookingLogsService();
